import * as React from "react";
import QueryForm from '../components/views/QueryForm/index';
import PaymentForm from '../components/views/PaymentForm/index';
import InvoiceDetail from '../components/views/InvoiceDetail/index';
export var routes = [
    {
        path: "/",
        element: React.createElement(QueryForm, null),
        children: [
            { index: true, element: React.createElement(QueryForm, null) },
        ],
    },
    {
        path: "/:refOrNumber",
        element: React.createElement(QueryForm, null),
        children: [
            { index: true, element: React.createElement(QueryForm, null) },
        ],
    },
    {
        path: "/pago",
        element: React.createElement(PaymentForm, null),
        children: [
            { index: true, element: React.createElement(PaymentForm, null) }
        ],
    },
    {
        path: "/detalle",
        element: React.createElement(InvoiceDetail, null),
        children: [
            { index: true, element: React.createElement(InvoiceDetail, null) }
        ],
    },
];
